var $carousels = $(".carousel-section-inner");

$carousels.each(function () {
  const centered = $(this).data("centered"),
    nav = $(this).data("nav"),
    dots = $(this).data("dots"),
    loop = $(this).data("loop"),
    slideTransition = $(this).data("slidetransition"),
    autoplay = $(this).data("autoplay"),
    autoplayHoverPause = $(this).data("autoplayhoverpause"),
    autoplaySpeed = $(this).data("autoplayspeed"),
    itemsmobile = $(this).data("itemsmobile"),
    itemstablet = $(this).data("itemstablet"),
    itemsdesktop = $(this).data("itemsdesktop");

  $(this)
    .find(".owl-carousel")
    .owlCarousel({
      stagePadding: 30,
      margin: 20,
      center: centered,
      nav: nav,
      dots: dots,
      loop: loop,
      slideTransition: slideTransition,
      autoplay: autoplay,
      autoplayHoverPause: autoplayHoverPause,
      autoplaySpeed: autoplaySpeed,
      smartSpeed: autoplaySpeed,
      responsive: {
        0: {
          items: itemsmobile,
        },
        640: {
          items: itemstablet,
        },
        769: {
          items: itemsdesktop,
        },
      },
    });
});
